export const RENEW_FRACTION = 0.8; // 80% of lifetime

// List all routes that require authentication
export const AUTH_REQUIRED = ['/api/v1/conversations', '/api/v1/ws', 'servlet/gcs/'];

// All userTypes that can see the chatbot
export const AUTHORISED_CHATBOT_USERS = 'AI_CHAT';
